"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.getHandles = exports.JonesPatterns = exports.JonesOptionType = exports.JonesPatternType = void 0;
var defs_1 = require("./defs");
var AspectsPatterns_1 = require("./AspectsPatterns");
var JonesOptions = (function () {
    function JonesOptions() {
    }
    JonesOptions.isBreakwater = function (objects, sector) {
        var _c;
        return new JonesOption(JonesOptionType.Breakwater, "chronos.app.instruments.jonesPatterns.breakwater", [objects[(_c = JonesPatterns.getMaxDistance(objects).to) !== null && _c !== void 0 ? _c : 0]]);
    };
    JonesOptions.isFinalizing = function (objects, sector) {
        var _c;
        return new JonesOption(JonesOptionType.Finalizing, "chronos.app.instruments.jonesPatterns.concluding", [objects[(_c = JonesPatterns.getMaxDistance(objects).from) !== null && _c !== void 0 ? _c : 0]]);
    };
    JonesOptions.isHand = function (objects) {
        return new JonesOption(JonesOptionType.Handle, "chronos.app.instruments.jonesPatterns.pen", __spreadArray([], objects, true));
    };
    JonesOptions.isTeeth = function (objects) {
        return new JonesOption(JonesOptionType.Teeth, "chronos.app.instruments.jonesPatterns.teeth", __spreadArray([], objects, true));
    };
    return JonesOptions;
}());
var JonesPatternType;
(function (JonesPatternType) {
    JonesPatternType[JonesPatternType["Sling"] = 0] = "Sling";
    JonesPatternType[JonesPatternType["Basket"] = 1] = "Basket";
    JonesPatternType[JonesPatternType["Swing"] = 2] = "Swing";
    JonesPatternType[JonesPatternType["Bunch"] = 3] = "Bunch";
    JonesPatternType[JonesPatternType["Bowl"] = 4] = "Bowl";
    JonesPatternType[JonesPatternType["Locomotive"] = 5] = "Locomotive";
    JonesPatternType[JonesPatternType["Thickening"] = 6] = "Thickening";
    JonesPatternType[JonesPatternType["Spray"] = 7] = "Spray";
})(JonesPatternType = exports.JonesPatternType || (exports.JonesPatternType = {}));
var JonesOptionType;
(function (JonesOptionType) {
    JonesOptionType[JonesOptionType["Breakwater"] = 0] = "Breakwater";
    JonesOptionType[JonesOptionType["Finalizing"] = 1] = "Finalizing";
    JonesOptionType[JonesOptionType["Handle"] = 2] = "Handle";
    JonesOptionType[JonesOptionType["Teeth"] = 3] = "Teeth";
})(JonesOptionType = exports.JonesOptionType || (exports.JonesOptionType = {}));
var JonesPattern = (function () {
    function JonesPattern(type, name, options) {
        this.type = type;
        this.name = name;
        this.options = options;
    }
    return JonesPattern;
}());
var JonesOption = (function () {
    function JonesOption(type, name, objects) {
        this.type = type;
        this.name = name;
        this.objects = objects;
    }
    return JonesOption;
}());
var JonesPatterns = (function () {
    function JonesPatterns(objects, houses, aspects, aspectsPatterns) {
        this.objects = [];
        this.objects = objects
            .map(function (item, id) { return ({ lon: item.lon + (180 - (houses[0] || 0)), id: id }); })
            .map(function (item) { return ({ lon: item.lon >= 0 ? item.lon : item.lon + 360, id: item.id }); })
            .map(function (item) { return ({ lon: item.lon % 360, id: item.id }); })
            .sort(function (a, b) { return a.lon >= b.lon ? 1 : -1; });
        this.aspectsPatterns = aspectsPatterns;
        this.aspects = aspects;
    }
    JonesPatterns.prototype.getPattern = function () {
        return this.isSling() ||
            this.isBasket() ||
            this.isSwing() ||
            this.isBunch() ||
            this.isBowl() ||
            this.isLocomotive() ||
            this.isThickening() ||
            this.isSpray();
    };
    JonesPatterns.prototype.isBowl = function () {
        if (this.isInOneSector(this.objects, 180, 0)) {
            var options = [];
            var breakwater = JonesOptions.isBreakwater(this.objects, 180);
            if (breakwater) {
                options.push(breakwater);
            }
            var finalizing = JonesOptions.isFinalizing(this.objects, 180);
            if (finalizing) {
                options.push(finalizing);
            }
            return new JonesPattern(JonesPatternType.Bowl, "chronos.app.instruments.jonesPatterns.bowl", options);
        }
    };
    JonesPatterns.prototype.isBasket = function () {
        rotate: for (var r = 0; r < 360; r++) {
            var sector180 = [];
            var sector30 = [];
            for (var i = 0; i < this.objects.length; i++) {
                var el = this.objects[i];
                if (this.isInSector(el, 0 + r, 180 + r)) {
                    sector180.push(el);
                }
                else if (this.isInSector(el, 255 + r, 285 + r)) {
                    sector30.push(el);
                }
                else {
                    continue rotate;
                }
                if (sector30.length > 2) {
                    continue rotate;
                }
            }
            if (sector30.length > 0 && this.isInAngles(sector180, 150, 180)) {
                var options = [];
                var breakwater = JonesOptions.isBreakwater(sector180, 180);
                if (breakwater) {
                    options.push(breakwater);
                }
                var finalizing = JonesOptions.isFinalizing(sector180, 180);
                if (finalizing) {
                    options.push(finalizing);
                }
                var hand = JonesOptions.isHand(sector30);
                if (hand) {
                    options.push(hand);
                }
                return new JonesPattern(JonesPatternType.Basket, "chronos.app.instruments.jonesPatterns.basket", options);
            }
        }
    };
    JonesPatterns.prototype.isBunch = function () {
        if (this.isInOneSector(this.objects, 120, 0)) {
            var options = [];
            var breakwater = JonesOptions.isBreakwater(this.objects, 120);
            if (breakwater) {
                options.push(breakwater);
            }
            var finalizing = JonesOptions.isFinalizing(this.objects, 120);
            if (finalizing) {
                options.push(finalizing);
            }
            return new JonesPattern(JonesPatternType.Bunch, "chronos.app.instruments.jonesPatterns.bundle", options);
        }
    };
    JonesPatterns.prototype.isSling = function () {
        rotate: for (var r = 0; r < 360; r++) {
            var sector150 = [];
            var sector30 = [];
            for (var i = 0; i < this.objects.length; i++) {
                var el = this.objects[i];
                if (this.isInSector(el, 0 + r, 150 + r)) {
                    sector150.push(el);
                }
                else if (this.isInSector(el, 240 + r, 270 + r)) {
                    sector30.push(el);
                }
                else {
                    continue rotate;
                }
                if (sector30.length > 2) {
                    continue rotate;
                }
            }
            if (sector30.length > 0) {
                var options = [];
                var breakwater = JonesOptions.isBreakwater(sector150, 150);
                if (breakwater) {
                    options.push(breakwater);
                }
                var finalizing = JonesOptions.isFinalizing(sector150, 150);
                if (finalizing) {
                    options.push(finalizing);
                }
                var hand = JonesOptions.isHand(sector30);
                if (hand) {
                    options.push(hand);
                }
                return new JonesPattern(JonesPatternType.Sling, "chronos.app.instruments.jonesPatterns.sling", options);
            }
        }
    };
    JonesPatterns.prototype.isLocomotive = function () {
        if (this.isInOneSector(this.objects, 240, 0)) {
            var options = [];
            var breakwater = JonesOptions.isBreakwater(this.objects, 240);
            if (breakwater) {
                options.push(breakwater);
            }
            var finalizing = JonesOptions.isFinalizing(this.objects, 240);
            if (finalizing) {
                options.push(finalizing);
            }
            return new JonesPattern(JonesPatternType.Locomotive, "chronos.app.instruments.jonesPatterns.locomotive", options);
        }
    };
    JonesPatterns.prototype.isSwing = function () {
        var objectsInSectors = [];
        var sectorI = 0;
        for (var i = 0; i < this.objects.length; i++) {
            if (!Array.isArray(objectsInSectors[sectorI])) {
                objectsInSectors[sectorI] = [];
            }
            objectsInSectors[sectorI].push(this.objects[i]);
            var nextI = i + 1 < this.objects.length ? i + 1 : 0;
            var distance = this.calculateArc(this.objects[i], this.objects[nextI]);
            if (distance >= 90) {
                sectorI++;
            }
            if (sectorI > 2) {
                return;
            }
        }
        if (sectorI === 2) {
            var sector1 = objectsInSectors[0];
            if (Array.isArray(objectsInSectors[sectorI])) {
                sector1.push.apply(sector1, objectsInSectors[sectorI]);
            }
            var sector2 = objectsInSectors[1];
            if (sector1.length >= 2 && sector2.length >= 2) {
                var options = [];
                var breakwater1 = JonesOptions.isBreakwater(sector1, 90);
                if (breakwater1) {
                    options.push(breakwater1);
                }
                var finalizing1 = JonesOptions.isFinalizing(sector1, 90);
                if (finalizing1) {
                    options.push(finalizing1);
                }
                var breakwater2 = JonesOptions.isBreakwater(sector2, 90);
                if (breakwater2) {
                    options.push(breakwater2);
                }
                var finalizing2 = JonesOptions.isFinalizing(sector2, 90);
                if (finalizing2) {
                    options.push(finalizing2);
                }
                return new JonesPattern(JonesPatternType.Swing, "chronos.app.instruments.jonesPatterns.swing", options);
            }
        }
    };
    JonesPatterns.prototype.isSpray = function () {
        var options = [];
        return new JonesPattern(JonesPatternType.Spray, "chronos.app.instruments.jonesPatterns.spray", options);
    };
    JonesPatterns.prototype.isThickening = function () {
        if (this.aspects.find(function (item) { return item.type == 0; })) {
            var options = [];
            return new JonesPattern(JonesPatternType.Thickening, "chronos.app.instruments.jonesPatterns.sprayWithThickening", options);
        }
        for (var r = 0; r < 360; r++) {
            var sector30 = [];
            for (var i = 0; i < this.objects.length; i++) {
                var el = this.objects[i];
                if (this.isInSector(el, 0 + r, 30 + r)) {
                    sector30.push(el);
                }
            }
            if (sector30.length >= 3) {
                var options = [];
                return new JonesPattern(JonesPatternType.Thickening, "chronos.app.instruments.jonesPatterns.sprayWithThickening", options);
            }
        }
    };
    JonesPatterns.prototype.isInSector = function (object, from, to) {
        if (from < 360 && to < 360) {
            return object.lon >= from && object.lon <= to;
        }
        if (from >= 360 && to >= 360) {
            return object.lon >= from - 360 && object.lon <= to - 360;
        }
        return object.lon >= from && object.lon <= 360 || object.lon >= 0 && object.lon <= to - 360;
    };
    JonesPatterns.prototype.isInOneSector = function (objects, radius, delay) {
        if (delay === void 0) { delay = 0; }
        var maxDistance = 0;
        for (var i = 0; i < objects.length; i++) {
            var nextI = i === objects.length - 1 ? 0 : i + 1;
            var distance = this.calculateArc(objects[i], objects[nextI]);
            if (distance > maxDistance) {
                maxDistance = distance;
            }
        }
        var minArc = 360 - maxDistance;
        return minArc < radius;
    };
    JonesPatterns.prototype.isInAngles = function (objects, min, max) {
        var maxDistance = 0;
        for (var i = 0; i < objects.length; i++) {
            var nextI = i === objects.length - 1 ? 0 : i + 1;
            var distance = this.calculateArc(objects[i], objects[nextI]);
            if (distance > maxDistance) {
                maxDistance = distance;
            }
        }
        var minArc = 360 - maxDistance;
        return minArc >= min && minArc <= max;
    };
    JonesPatterns.getMaxDistance = function (objects) {
        var maxDistance = 0;
        var maxDistancePrevIndex = null;
        var maxDistanceNextIndex = null;
        for (var i = 0; i < objects.length; i++) {
            var nextIndex = i === objects.length - 1 ? 0 : i + 1;
            var distance = JonesPatterns.calculateDelta(objects[nextIndex], objects[i]);
            if (distance > maxDistance) {
                maxDistance = distance;
                maxDistancePrevIndex = i;
                maxDistanceNextIndex = nextIndex;
            }
        }
        return {
            distance: maxDistance,
            from: maxDistancePrevIndex,
            to: maxDistanceNextIndex
        };
    };
    JonesPatterns.prototype.calculateArc = function (a, b) {
        if (a.lon > b.lon) {
            return 360 - (a.lon - b.lon);
        }
        return Math.abs(a.lon - b.lon);
    };
    JonesPatterns.calculateDelta = function (_a, _b) {
        var max, min;
        if (_a.lon > _b.lon) {
            max = _a.lon;
            min = _b.lon;
        }
        else {
            max = _b.lon;
            min = _a.lon;
        }
        var delta = max - min;
        if (delta < 180 && delta > 0) {
            return delta;
        }
        return 360 - delta;
    };
    JonesPatterns.prototype.calculateAngle = function (a) {
        return a.lon < 360 ? a.lon : a.lon - 360;
    };
    return JonesPatterns;
}());
exports.JonesPatterns = JonesPatterns;
function getHandles(data, patterns) {
    var aspects = data.aspects.filter(function (a) { return a.obj1 <= defs_1.ObjectType.Pluto && a.obj2 <= defs_1.ObjectType.Pluto; });
    var aspectsPatterns = new AspectsPatterns_1.AspectsPatterns(aspects).findPatterns();
    var objects = data.objects.filter(function (_, i) { return i <= defs_1.ObjectType.Pluto; });
    var jonesPattern = new JonesPatterns(objects, data.houses, data.aspects, aspectsPatterns).getPattern();
    var result = [];
    if (patterns.includes(jonesPattern.type)) {
        jonesPattern.options.forEach(function (o) {
            if (o.type === JonesOptionType.Handle) {
                result.push.apply(result, o.objects);
            }
        });
    }
    return result;
}
exports.getHandles = getHandles;
